export default __webpack_public_path__ + "static/media/error-bg-light.6e29384e.svg";